const translations = {
  app_name: "FormWeg",
  customers: {
    assigned_to: "Assigned inspector",
    assign_to_me: "Assign to me",
    unassigned: "Unassigned",
  },
  delivery_notes: {
    assigned_to: "Assigned to",
    assign_to_me: "Assign to me",
    unassigned: "Unassigned",
    removed_from_template: "No longer in {{name}} template",
    errors: {
      number_already_exists: "Item number already exists in the template",
    },
    menu: {
      confirm_copy: "Do you really want to copy this $t(delivery_notes.delivery_note)?",
      advancing_next: "Advancing to next $t(delivery_notes.delivery_note)…",
    },
  },
  files: {
    confirm_delete: "Are you sure you want to delete this file?",
  },
  transcription: {
    recording: "Recording...",
    transcribing: "Transcribing...",
    error: "Transcription failed",
    mic_denied: "Microphone access denied",
  },
  menu: {
    home: "Home",
    translations: "Labels",
    integrations: "Integrations",
    inspection_cards: "Inspection Cards",
    drafts: "Drafts",
    review: "To Review",
    logout: "Log Out",
  },
  inspections: {
    title: "Inspection Cards",
    month: "Month",
    year: "Year",
    month_invalid: "Invalid month",
    inspector: "Inspector",
    customer_nr: "Customer no.",
    customer: "Customer",
    property_nr: "Property no.",
    property: "Property",
    device_type: "Device type",
    next_inspection: "Next inspection",
    last_inspection: "Last inspection",
    schedule: "Schedule",
    interval: "Interval",
    card: "Inspection card",
    code: "Code",
    remark: "Remark",
    communications: "Communications",
    medium: "Medium",
    number: "Number",
    quantity: "Quantity",
    no_results: "No inspections found",
    tab_list: "List",
    tab_map: "Map",
    map_stats: "{{located}} of {{total}} shown — {{unlocated}} addresses could not be located",
    map_loading: "Loading map...",
    map_empty: "No inspections available for the selected filters.",
    map_error: "Could not load map data.",
    map_legend: "Legend",
    map_legend_unknown: "Unknown",
  },
  nominatim: {
    unavailable:
      "The mapping service is currently unavailable. " +
      "Addresses cannot be displayed on the map.",
    unavailable_short: "Mapping service unavailable",
  },
  settings: {
    translations: {
      title: "Labels",
      description: "Customize labels for menu items and forms",
      delivery_notes_plural: "Delivery Notes (Plural)",
      delivery_notes_singular: "Delivery Note (Singular)",
      templates_plural: "Templates (Plural)",
      templates_singular: "Template (Singular)",
    },
    natrav: {
      title: "Secure Connection (Tunnel)",
      service: "Service",
      server: "Server",
      token: "Token",
      lokal: "Local",
      port: "Port",
    },
    sqlbase: {
      title: "SQLBase",
      db_name: "Database Name",
      username: "Username",
      password: "Password",
      confirm_overwrite: "Overwrite existing settings?",
      connection_ok: "Database connection successful. The connection will be active within 30 seconds.",
      connection_failed: "Database connection failed",
      authorization_title: "Authorization for Read-Only Database Access",
      authorization_accept: "Accept",
      authorization_accepted_by: "Accepted by {{name}} on {{date}} for {{db_name}} ({{version}})",
    },
  },
  common: {
    close: "Close",
    confirm_unsaved_changes:
      "You have unsaved changes. Are you sure you want to leave?",
    deleted: "Deleted",
  },
  errors: {
    item: {
      number_exists: "An item with this number already exists",
    },
    delivery_note: {
      invalid_transition: "Transition from {{from}} to {{to}} is not allowed",
      transition_forbidden: "Transition from {{from}} to {{to}} is not allowed for your role",
    },
    unknown: "An unknown error occurred",
  },
};

export default translations;
